import React from "react";

export default function MenuConexaoAudiencia() {
  const sections = [
    {
      path: "/como-conectar-minha-conta-do-facebook-ou-instagram",
      title: "Como conectar minha conta do Facebook ou Instagram?",
    },
    {
      path: "/solucao-de-problemas-conta-de-anuncio",
      title: "Solução de problemas - Conta de Anúncio",
    },
    {
      path: "/solucao-de-problemas-publicos-personalizados-do-facebook",
      title: "Solução de problemas - Públicos personalizados do Facebook",
    },
  ];

  function isPaginaEspecifica(path) {
    return window.location.pathname === path;
  }

  return (
    <div>
      <h4>Artigos nessa seção</h4>
      <ul
        className="nav categories-nav nav-pills flex-column"
        role="navigation"
      >
        <li className="nav-item open">
          <ul className="nav nav-pills flex-column">
            {sections.map((section, index) => (
              <li className="nav-item" key={index}>
                <a
                  className={`nav-link ${
                    isPaginaEspecifica(section.path) ? "active" : ""
                  }`}
                  href={
                    isPaginaEspecifica(section.path) ? undefined : section.path
                  }
                >
                  {section.title}
                </a>
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </div>
  );
}
